import { CustomSnackBarComponent } from "../components/custom-snack-bar/custom-snack-bar.component";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class CustomSnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  mensagens: any[] = [];
  isVisible = false;

  openSnackBar(message: string, action: string | null, snackType: string = "Success", duration: number = 3) {
    // Remover barras para quando o retorno da API Progress possui alguma palavra entre aspas
    message = message?.replace(/\\"/g, '"');

    var mensagem = 
    {
      message: message,
      snackType: snackType,
      duration: duration
    };

    this.mensagens.push(mensagem);

    if (!this.isVisible)
    {
      this.showNext();
    }

  }

  private showNext()
  {
    if (this.mensagens.length===0)
    {
      return;
    }

    var mensagem = this.mensagens.shift();
    this.isVisible = true;

    this.snackBar.openFromComponent(CustomSnackBarComponent, {
      duration: mensagem.duration * 1500,
      verticalPosition: "top",
      data: { message: mensagem.message, snackType: mensagem.snackType, duration: mensagem.duration * 1500 },
    });

    this.snackBar._openedSnackBarRef?.afterDismissed().subscribe(() =>
    {
      this.isVisible = false;
      this.showNext();
    });

  }
}
